module.exports = __webpack_public_path__ + "img/icon-25.be4039c7.png";